document.addEventListener("DOMContentLoaded", function() {
  const translations = {
    en: {
      flipr: "flipr",
      iphone: "iPhone",
      ipad: "iPad",
      chemicals: "Chemicals"
    },
    fr: {
      flipr: "flipr",
      iphone: "iPhone",
      ipad: "iPad",
      chemicals: "Chimie"
    }
    // Add more languages and translations as needed
  };

  // Check if Shopify.locale is available
  console.log("Shopify.locale: ", Shopify.locale);

  // Use Shopify.locale if available, otherwise fallback to 'fr' for testing
  const selectedLang = Shopify.locale || 'fr'; // Default to French if no locale is found

  console.log("Selected Language: ", selectedLang);

  document.querySelectorAll("[data-translate]").forEach(function(element) {
    const key = element.getAttribute("data-translate");
    console.log(`Translating key: ${key} to ${translations[selectedLang][key]} for element: `, element);
    if (translations[selectedLang] && translations[selectedLang][key]) {
      element.textContent = translations[selectedLang][key];
    }
  });
});
